import React, { useEffect } from "react";

import CloneChildren from "@components/children";

import { CommonProps } from "@utils/interface";
import { useOnload } from "@utils/useRunOnload";
interface PlansContainerInterface extends CommonProps {}

const PlansContainer = ({ children, ...props }: PlansContainerInterface) => {
  const { actions, id } = props;
  const { on_load } = actions || {};

  useOnload({ id, on_load });

  return (
    <CloneChildren
      children={children}
      props={props}
      styles={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "1rem"
      }}
    />
  );
};

export default PlansContainer;
